import { render, staticRenderFns } from "./SocialBarSimple.vue?vue&type=template&id=129983ef&scoped=true&"
import script from "./SocialBarSimple.vue?vue&type=script&lang=js&"
export * from "./SocialBarSimple.vue?vue&type=script&lang=js&"
import style0 from "./SocialBarSimple.vue?vue&type=style&index=0&id=129983ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129983ef",
  null
  
)

export default component.exports